"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Icone = require("../elements/Icone");

var _Icone2 = _interopRequireDefault(_Icone);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

require("../../assets/css/components/navegacao/Paginator.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Paginator = function (_React$Component) {
    _inherits(Paginator, _React$Component);

    function Paginator() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Paginator);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Paginator.__proto__ || Object.getPrototypeOf(Paginator)).call.apply(_ref, [this].concat(args))), _this), _this.getPaginateInfo = function (size, page, totalElements, last) {
            if (_this.props.table) {
                return size * (page + 1) < totalElements ? _react2.default.createElement(
                    "span",
                    { className: "flat-table-info" },
                    page * size + 1,
                    " - ",
                    size * (page + 1) + " ",
                    "de ",
                    totalElements,
                    " "
                ) : _react2.default.createElement(
                    "span",
                    { className: "flat-table-info" },
                    page * size + 1,
                    " - ",
                    totalElements,
                    " de ",
                    totalElements
                );
            }

            return _react2.default.createElement(
                "span",
                null,
                "Exibindo ",
                last ? totalElements : page * size + size,
                " de ",
                totalElements
            );
        }, _this.getPaginator = function (page, elementsPerPage, totalElements, first, last) {
            if (_this.props.simple) return _this.getSimplePaginator(page, elementsPerPage, totalElements, first, last);
            return _this.getDefaultPaginator(first, last);
        }, _this.getSimplePaginator = function (page, elementsPerPage, totalElements, first, last) {
            return _react2.default.createElement(
                "div",
                { className: _this.props.table ? "flat-table-navigation" : "paginator" },
                _react2.default.createElement(
                    "button",
                    { type: "button", id: "previous", className: first ? 'disable' : '', onClick: _this.onPageChange,
                        alt: "Voltar" },
                    _react2.default.createElement(_Icone2.default, { icone: "angle-left", fontAwesome: true })
                ),
                _react2.default.createElement(
                    "button",
                    { type: "button", id: "next", className: last ? 'disable' : '', onClick: _this.onPageChange },
                    _react2.default.createElement(_Icone2.default, { icone: "angle-right", fontAwesome: true })
                ),
                _this.getPaginateInfo(elementsPerPage, page, totalElements, last)
            );
        }, _this.getDefaultPaginator = function (first, last) {
            return _react2.default.createElement(
                "div",
                { className: "simplePaginator" },
                _react2.default.createElement(
                    "ul",
                    null,
                    _react2.default.createElement(
                        "li",
                        null,
                        _react2.default.createElement(
                            "button",
                            { type: "button", id: "previous", className: first ? 'disable' : '',
                                onClick: _this.onPageChange,
                                alt: "Voltar" },
                            _react2.default.createElement(_Icone2.default, { icone: "angle-left", fontAwesome: true })
                        )
                    ),
                    _this.getFistPages(),
                    _this.getLastPages(),
                    _react2.default.createElement(
                        "li",
                        null,
                        _react2.default.createElement(
                            "button",
                            { type: "button", id: "next", className: last ? 'disable' : '', onClick: _this.onPageChange },
                            _react2.default.createElement(_Icone2.default, { icone: "angle-right", fontAwesome: true })
                        )
                    )
                )
            );
        }, _this.getFistPages = function () {
            var array = [];
            if (_this.data.number >= 0) array.push(_this.getPageLi(1));
            if (_this.data.number - 2 > 0) array.push(_this.getPageLi('more-back'));
            if (_this.data.number - 1 > 0) array.push(_this.getPageLi(_this.data.number));
            if (_this.data.number > 0) array.push(_this.getPageLi(_this.data.number + 1));
            return array;
        }, _this.getLastPages = function () {
            var array = [];
            if (_this.data.number + 2 < _this.data.totalPages) array.push(_this.getPageLi(_this.data.number + 2));
            if (_this.data.number + 3 < _this.data.totalPages) array.push(_this.getPageLi('more-foward'));
            if (_this.data.number + 1 < _this.data.totalPages) array.push(_this.getPageLi(_this.data.totalPages));
            return array;
        }, _this.getPageLi = function (page) {
            return _react2.default.createElement(
                "li",
                { key: 'page-' + (page + 1) },
                _react2.default.createElement(
                    "button",
                    { value: page - 1, className: 'pagenumber ' + (page === _this.data.number + 1 ? 'active' : ''),
                        onClick: _this.onPageChange },
                    typeof page === 'string' ? "..." : page
                )
            );
        }, _this.onPageChange = function (event) {
            var page = null;
            if (event.target.getAttribute('id') === 'next') page = _this.data.number < _this.data.totalPages - 1 ? _this.data.number + 1 : _this.data.number;
            if (event.target.getAttribute('id') === 'previous') page = _this.data.number > 0 ? _this.data.number - 1 : 0;
            if (event.target.innerHTML !== '...') page ? _this.props.onPageChange(page) : _this.props.onPageChange(event.target.getAttribute('value'));
        }, _this.getPagination = function () {
            _this.data = _this.props.data;
            return _this.props.collection ? _this.paginateCollection(_this.props.data, _this.props.qtElements, _this.props.page) : _this.getPaginator(_this.props.data.number, _this.props.data.size, _this.props.data.totalElements, _this.props.data.first, _this.props.data.last);
        }, _this.paginateCollection = function (data, size, page) {
            _this.data = Object.assign(_this.data, {
                totalElements: _this.props.totalElements || data.length,
                totalPages: Math.ceil((_this.props.totalElements || data.length) / size),
                elementsPerPage: size,
                first: page === 0,
                last: page >= Math.ceil((_this.props.totalElements || data.length) / size) - 1,
                number: Number(page)
            });
            return _this.getPaginator(page, size, _this.data.totalElements, _this.data.first, _this.data.last);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Paginator, [{
        key: "render",
        value: function render() {
            return this.getPagination();
        }
    }]);

    return Paginator;
}(_react2.default.Component);

exports.default = Paginator;


Paginator.propTypes = {
    data: _propTypes2.default.any,
    simple: _propTypes2.default.bool,
    collection: _propTypes2.default.bool,
    table: _propTypes2.default.bool,
    page: _propTypes2.default.number,
    onPageChange: _propTypes2.default.func,
    qtElements: _propTypes2.default.any.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/navegacao/Paginator.js
// module id = 588
// module chunks = 0